import { render, staticRenderFns } from "./Attribution.vue?vue&type=template&id=2f5bd3ec&scoped=true&lang=html&"
import script from "./Attribution.vue?vue&type=script&lang=js&"
export * from "./Attribution.vue?vue&type=script&lang=js&"
import style0 from "./Attribution.vue?vue&type=style&index=0&id=2f5bd3ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5bd3ec",
  null
  
)

export default component.exports